module.exports = __webpack_public_path__ + "static/favicon-a26b3c8a1b1c54ecbee689af121322ff.ico";